import type { StaticLayerPayload } from "@config";
import { SlideLibrary } from "@library-layers/slide";
import { Container } from "../Container";

export const Slide = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={{ default: SlideLibrary }} />
);
